<script>
export default {
    name: "ProfitAndLoss",

    data() {

        return {
           
           orderval:0,
            filter: {
                userName: this.$root.username,
                incomeStatementDetails: [
                    {
                        fromDate: this.$moment().format(`YYYY-MM-DD`),
                        toDate: this.$moment().format(`YYYY-MM-DD`)
                    },
                ]
            },
            defaultFilter: 1,
            fps: [],
            pLcs: {
                incomeStatementDetails: [],
            }
        };
    },

    computed: {

        groups() {
            if(!this.pLcs.incomeStatementDetails.length) return [];

            let groups = this.pLcs.incomeStatementDetails.map(income => income.groupId);

            let groupsSet = new Set(groups);

            return Array.from(groupsSet);
        },incomeparticulars() {
            if(!this.pLcs.incomeStatementDetails.length) return [];

            let groups = this.pLcs.incomeStatementDetails.map(income => income.particulars);

            let groupsSet = new Set(groups);

            return Array.from(groupsSet);
        },
    },

    watch: {

        defaultFilter() {

            switch (this.defaultFilter) {
                    case 1: 
                        this.filter.incomeStatementDetails = [{
                                fromDate: this.$moment().format(`YYYY-MM-DD`),
                                toDate: this.$moment().format(`YYYY-MM-DD`)
                            }];
                        break;
                    case 2:
                        this.filter.incomeStatementDetails = [{
                                fromDate: this.$moment().format(`YYYY-MM-DD`),
                                toDate: this.$moment().format(`YYYY-MM-DD`)
                            }];
                        this.filter.incomeStatementDetails.push({
                            fromDate: null,
                            toDate: null
                        });
                        break;
                    case 3:
                        this.filter.incomeStatementDetails = [{
                                fromDate: this.$moment().format(`YYYY-MM-DD`),
                                toDate: this.$moment().format(`YYYY-MM-DD`)
                            }];
                        this.filter.incomeStatementDetails.push(...[
                            {
                                fromDate: null,
                                toDate: null
                            },
                            {
                                fromDate: null,
                                toDate: null
                            },
                        ]);
                        break;
                    case 4:
                        this.filter.incomeStatementDetails = [{
                                fromDate: this.$moment().format(`YYYY-MM-DD`),
                                toDate: this.$moment().format(`YYYY-MM-DD`)
                            }];
                        this.filter.incomeStatementDetails.push(...[
                            {
                                fromDate: null,
                                toDate: null
                            },
                            {
                                fromDate: null,
                                toDate: null
                            },
                            {
                                fromDate: null,
                                toDate: null
                            }
                        ]);
                        break;
                    default:
                        break;
                }
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchFinancialPeriods(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchProfitAndLoss() {
            let url = `Accounting/ProfitnLoss`;

            return this.$http.post(url, this.filter).then(({ data }) => {
                this.pLcs = data;
            }).catch(() => {});
        },

        fetchFinancialPeriods() {

            return this.$http.get(`Accounts/GetFinancialPeriods`).then(({ data }) => {
                this.fps = data;
            }).catch(() => {});
        },

        printProfitLoss() {
            let url = `/finance-dashboard/coas/profit-loss/print`;
                url += `?from=${this.filter.from}`;
                url += `&to=${this.filter.to}`;
            
            window.open(url, `_blank`, `PrintProfitLoss`);
        },
        getOrderValue(particular) {
             this.orderval= this.pLcs.particulars.filter(g=>g.name==particular).map(g=>g.orderVal)[0];
             return this.orderval;
        },
       
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <div class="w-full flex flex-wrap items-center">
            <div class="md:w-1/6 w-full p-tiny">
                <label for="grid-depth" class="label-control">Depth</label>
                <tail-select>
                    <template v-slot:field>
                        <select id="grid-depth" v-model="defaultFilter" class="input-control input-sm text-xs">
                            <option :value="1">Default</option>
                            <option :value="2">Two</option>
                            <option :value="3">Three</option>
                            <option :value="4">Four</option>
                        </select>
                    </template>
                </tail-select>
            </div>
            <div class="md:w-4/6 w-full p-tiny flex flex-row">
                <div 
                    v-for="(dateFilter, idx) in filter.incomeStatementDetails" :key="idx"
                    class="w-1/5 flex flex-col">
                    <div class="w-full p-tiny">
                        <label class="label">Period</label>
                        <tail-select>
                            <template v-slot:field>
                                <select id="" class="input-control input-sm text-xs">
                                    <option :value="0">select period</option>
                                    <option v-for="fp in fps" 
                                        :key="fp.periodId" :value="fp.periodId">{{ fp.periodYr }}</option>
                                </select>
                            </template>
                        </tail-select>
                    </div>
                    <div class="w-full p-1">
                        <label for="grid-date-from" class="label-control">From:</label>
                        <input type="date" v-model.trim="dateFilter.fromDate" 
                            id="grid-date-from" class="input-control input-sm text-xs">
                    </div>
                    <div class="w-full p-1">
                        <label for="grid-date-to" class="label-control">To:</label>
                        <input type="date" v-model.trim="dateFilter.toDate" 
                            id="grid-date-to" class="input-control input-sm text-xs">
                    </div>
                </div>
            </div>
            <div class="md:w-1/6 w-full p-1">
                <button 
                    @click.prevent="() => {
                        $root.loading = true;
                        fetchProfitAndLoss().then(() => {
                            $root.loading = false;
                        });
                    }"
                    class="btn-sm btn-primary text-xs rounded mt-4">Filter</button>
            </div>
    </div>
    <!-- prevoius income statement display -->
        <!-- <div class="w-full overflow-auto" style="max-height:35rem;">
            <table class="table border" id="table-profit-n-loss">
                    <thead class="text-sm border-b-2 bg-gray-300">
                        <tr>
                            <th class="p-tiny whitespace-nowrap">
                                Ordinary Income/Expenses</th>
                            <th class="p-tiny whitespace-nowrap" v-for="grp in groups" :key="grp">
                                </th>
                        </tr>
                    </thead>
                    <thead class="text-sm border-b-2 bg-gray-200">
                        <tr>
                            <th class="p-tiny whitespace-nowrap">
                                <span class="ml-3">Income</span></th>
                            <th class="p-tiny whitespace-nowrap" v-for="grp in groups" :key="grp"></th>
                        </tr>
                    </thead>
                    <tbody class=" bg-gray-100">
                        <tr class="border-b-2" 
                            v-for="(pLc, idx) in 
                                pLcs.incomeStatementDetails.filter(pl => pl.sortname == `Income`)" 
                            :key="`__${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="p-tiny">
                                <span class="ml-6">{{ pLc.particulars }}</span>
                            </td>
                            <td class="p-tiny" v-for="grp in groups" :key="grp">
                                {{ 
                                    pLcs.incomeStatementDetails.filter(pl => 
                                        pl.sortname == `Income` && grp == pl.groupId).length ? 
                                        $formatCurrency(pLcs.incomeStatementDetails.filter(pl => 
                                            pl.sortname == `Income` && grp == pl.groupId)[0].value) : `-` 
                                }}
                            </td>
                        </tr>
                    </tbody>
                    <tbody class=" bg-gray-100">
                        <tr class="border-b-2" 
                            v-for="(pLc, idx) in pLcs.incomeStatementDetails.filter(pl => pl.particulars == `Other Income`)" 
                            :key="`__${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="p-tiny">
                                <span class="ml-6">{{ pLc.particulars }}</span>
                            </td>
                            <td class="p-tiny" v-for="grp in groups" :key="grp">

                                {{ 
                                    pLcs.incomeStatementDetails.filter(pl => 
                                        pl.particulars == `Other Income` && grp == pl.groupId).length ? 
                                    $formatCurrency(pLcs.incomeStatementDetails.filter(pl => 
                                        pl.particulars == `Other Income` && grp == pl.groupId)[0].value) :
                                        `-`
                                }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="text-sm border-b-2 bg-gray-300">
                        <tr>
                            <th class="p-tiny whitespace-nowrap">
                                <span class="ml-3">Other Income</span></th>
                            <th class="p-tiny whitespace-nowrap"  v-for="grp in groups" :key="grp"></th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100">
                        <tr class="border-b-2" 
                            v-for="(pLc, idx) in pLcs.incomeStatementDetails.filter(pl => pl.particulars == `Total Other Income`)" 
                            :key="`__${idx}`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="p-tiny">
                                <span class="ml-6">{{ pLc.particulars }}</span>
                            </td>
                            <td class="p-tiny"  v-for="grp in groups" :key="grp">
                                {{ 
                                    pLcs.incomeStatementDetails.filter(pl => 
                                        pl.particulars == `Total Other Income` && grp == pl.groupId).length ?
                                    $formatCurrency(pLcs.incomeStatementDetails.filter(pl => 
                                        pl.particulars == `Total Other Income` && grp == pl.groupId)[0].value) :
                                        `-`
                                }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="text-sm border-b-2 bg-gray-300">
                        <tr>
                            <th class="p-tiny whitespace-nowrap">
                                <span class="ml-3">Total Income</span></th>
                            <th class="p-tiny whitespace-nowrap" v-for="grp in groups" :key="grp">
                                {{ 
                                    pLcs.incomeStatementDetails.filter(pl => 
                                        pl.particulars == `Total Income` && grp == pl.groupId).length ?
                                      $formatCurrency(pLcs.incomeStatementDetails.filter(pl => 
                                        pl.particulars == `Total Income` && grp == pl.groupId)[0].value)
                                     : 0
                                }}</th>
                        </tr>
                    </thead>
                    <thead class="text-sm border-b-2 bg-gray-300">
                        <tr class="border-b-2">
                            <th class="p-tiny whitespace-nowrap">
                                Expenses</th>
                            <th class="p-tiny whitespace-nowrap" v-for="grp in groups" :key="grp">
                                </th>
                        </tr>
                        <tr v-for="(pLc, idx) in pLcs.incomeStatementDetails.filter(pl => 
                                pl.particulars == `Administrative Expenses`)"
                            :key="`${idx}__`"
                            class="border-b-2">
                            <th class="p-tiny whitespace-nowrap">
                                <span class="ml-4">{{ pLc.particulars }}</span></th>
                            <th class="p-tiny whitespace-nowrap" v-for="grp in groups" :key="grp">
                                {{ 
                                    pLcs.incomeStatementDetails.filter(pl => 
                                        pl.particulars == `Administrative Expenses` && grp == pl.groupId).length ? 
                                    $formatCurrency(pLcs.incomeStatementDetails.filter(pl => 
                                        pl.particulars == `Administrative Expenses` && grp == pl.groupId)[0].value) : 
                                        `-`
                                }}
                            </th>
                        </tr>
                        <tr v-for="(pLc, idx) in pLcs.incomeStatementDetails.filter(pl => 
                                pl.particulars == `Total Administrative Expenses`)"
                            :key="idx"
                            class="border-b-2">
                            <th class="p-tiny whitespace-nowrap">
                                <span class="ml-2">{{ pLc.particulars }}</span></th>
                            <th class="p-tiny whitespace-nowrap" v-for="grp in groups" :key="grp">
                                {{ 
                                    pLcs.incomeStatementDetails.filter(pl => 
                                        pl.particulars == `Total Administrative Expenses` && grp == pl.groupId).length ?
                                    $formatCurrency(pLcs.incomeStatementDetails.filter(pl => 
                                        pl.particulars == `Total Administrative Expenses` && grp == pl.groupId)[0].value) :
                                        `-`
                                }}
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-gray-100">
                        <tr class="border-b-2" 
                            v-for="(pLc, idx) in pLcs.incomeStatementDetails.filter(pl => pl.sortname == `Expenses`)" 
                            :key="`${idx}_`"
                            :class="idx%2 > 0 ? `bg-gray-100` : ``"
                            >
                            <td class="py-tiny capitalize">
                                <span class="ml-6">{{ pLc.particulars }}</span>
                            </td>
                            <td class="py-tiny" v-for="grp in groups" :key="grp">
                                {{ 
                                    pLcs.incomeStatementDetails.filter(pl => pl.sortname == `Expenses` && grp == pl.groupId).length ?
                                    $formatCurrency(pLcs.incomeStatementDetails.filter(pl => 
                                        pl.sortname == `Expenses` && grp == pl.groupId)[0].value) :
                                    `-`
                                 }}
                            </td>
                        </tr>
                    </tbody>
                    <thead class="text-sm border-b-2 bg-gray-200">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                <span class="ml-3">Total Expenses</span></th>
                            <th class="py-tiny whitespace-nowrap" v-for="grp in groups" :key="grp">
                                {{ 
                                    pLcs.incomeStatementDetails.filter(pl => pl.particulars == `Total Expenses` && grp == pl.groupId).length ?
                                      $formatCurrency(pLcs.incomeStatementDetails.filter(pl => 
                                        pl.particulars == `Total Expenses` && grp == pl.groupId)[0].value)
                                     : 0
                                }}
                            </th>
                        </tr>
                    </thead>
                    <thead class="text-sm border-b-2 bg-gray-300">
                        <tr>
                            <th class="py-tiny whitespace-nowrap">
                                <span>Net Ordinary Income</span></th>
                            <th class="py-tiny whitespace-nowrap" v-for="grp in groups" :key="grp">
                                {{ 
                                    pLcs.incomeStatementDetails.filter(pl => pl.particulars == `Net Ordinary Income` && grp == pl.groupId).length ?
                                      $formatCurrency(pLcs.incomeStatementDetails.filter(pl => pl.particulars == `Net Ordinary Income` && grp == pl.groupId)[0].value)
                                     : 0
                                }}
                            </th>
                        </tr>
                    </thead>
                </table>
        </div> -->
   <!-- end  prevoius income statement display -->
    
                     <table class="table table-hover">
            <thead class="bg-blue-500 text-xs text-white">
                <tr class="flex w-full">
                    <th class="p-tiny w-2/6">Income Statement  </th>
                
                     <th class="p-tiny  w-1/6 text-right" v-for="grp in groups" :key="grp">Value</th>
                </tr>
            </thead>
            <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:70vh;">
                <tr class="w-full flex" v-for="(particular, idx) in pLcs.particulars" :key="idx">
                <!-- <tr class="w-full flex" v-for="(particular, idx) in incomeparticulars" :key="idx" > -->
                    <!-- <td :class="if(particular.orderVal==1){classorder.class1} else if(particular.orderVal==2){classorder.class2}   else if(particular.orderVal==3){classorder.class3}    else if(particular.orderVal==4){classorder.class4}  else {classorder.class0}">{{ particular.name }}{{particular.orderVal}}</td> -->
                    <!-- {{orderval=()=>pLcs.particulars.filter(g=>g.name==particular).map(g=>g.orderVal)[0]}} -->
                   
                    <td class="p-tiny w-2/6">  
                        <div :class="{
                            'ml-1 font-bold':  particular.orderVal== 0 ,
                            'ml-1 font-bold':  particular.orderVal== 1 ,
                            'ml-3 font-bold':  particular.orderVal== 2,
                            'ml-5':  particular.orderVal== 3,
                            'ml-7': particular.orderVal== 4,
                            
                        }">
 {{ particular.name }}  
                        </div>   
                        <!-- <p :class="particular.orderVal==1? classorder.class1: particular.orderVal==2? classorder.class2: particular.orderVal==3? classorder.class3: particular.orderVal==4? classorder.class4: classorder.class0"> {{ particular.name }}{{particular.orderVal}}</p> -->
                        </td>
                    <td class="p-tiny  w-1/6 text-right" v-for="grp in groups" :key="grp">
                    <div :class="{
                             'mr-1 font-bold underline':  particular.orderVal== 1 ,
                             'mr-3 font-bold underline':  particular.orderVal== 2,
                             'mr-5':  particular.orderVal== 3,
                             'mr-7': particular.orderVal== 4,
                            
                        }">
 {{ 
                                    pLcs.incomeStatementDetails.filter(pl => 
                                        pl.particulars == particular.name && pl.groupId==grp ).length ? 
                                      particular.orderVal==0 || (particular.orderVal==1 && !(particular.name.includes("Total") || particular.name.includes("Net")))?'':  $formatCurrency(pLcs.incomeStatementDetails.filter(pl => 
                                            pl.particulars == particular.name  && pl.groupId==grp)[0].value) : `-` 
                                }}
                        </div>  
                    </td>
                     
                </tr>
            </tbody>
        </table>
   </div>
</template>